/* eslint-disable */
import throwModelNotFoundByIdError from '../../Errors/Model/ModelNotFoundById.error';
import { ordersFixture } from './Order.service.fixture';
import { Order } from 'types/Order';
import getActivityLogService from './services/get-activity-log';
import isTooLateForPlusLoadService from './services/is-too-late-for-plus-load';

/**
 * MockOrderService
 */
class MockOrderService {
  _baseUrl = `/`;
  authService: any;
  httpService: any
  constructor({ authService, httpService }: any) {
    this.authService = authService;
    this.httpService = httpService;
  }

  /**
   * Fetch all known orders
   * @returns {Promise<Array<OrderEntity>>} The orders
   * @memberof MockOrderService
   */
  all = async () => {
    return ordersFixture;
  };

  /**
   * Confirm an Order by its `date`,`orderCode` and `status`
   * @param {any} dto The required params to confirm an `order` by its `status`, `orderCode`, `date`
   * @returns {Promise<OrderEntity>} The confirm `order`
   * @memberof MockOrderService
   */
  confirmOrder = async ({ date, orderCode, status }: any) => {};

  /**
   * Find an order by its `id`
   * @param {UserServiceFindByIdDto} dto The required params to find an `order` by its `id`
   * @returns {Promise<OrderEntity>} The found `order`
   * @memberof MockOrderService
   */
  findById = async ({ id }: any) => {
    const foundOrder = ordersFixture.find((order) => order.id === id);
    if (foundOrder === undefined) {
      return throwModelNotFoundByIdError(`Order`, id);
    }
    return foundOrder;
  };

  /**
   * Find an order by its `orderCode`, `orderLine` and `status`
   * @param {any} dto The required params to find an `order` by its `status`, `orderCode`, `orderLine`
   * @returns {Promise<OrderEntity>} The found `order`
   * @memberof MockOrderService
   */
  findByStatus = async ({ orderCode, orderLine, status }: any) => {};

  /**
   * Find linked orders
   * @param {any} dto The required params to find an `order` by its `date`, `orderCode`
   * @returns {Promise<OrderEntity>} The found `order`
   * @memberof OrderService
   */
  findLinked = async ({ date, orderCode }: any) => {};

  /**
   * Gets the unique status id
   * @param {any} dto The required params to get a unique status id by its `status`, `orderCode`, `orderLine`
   * @returns {Promise<OrderEntity>} The found `order`
   * @memberof MockOrderService
   */
  getStatusId = ({ orderCode, orderLine, status }: any) => {
    return ``;
  };

  /**
   * Get current user accounts
   * @returns {Promise<Array<OrderAddressEntity>>} The orders
   * @memberof OrderService
   */
  getProjects = async () => {
    return [];
  };

  /**
   * Gets the unique status id
   * @param {any} dto The required params to get a unique status id by its `status`, `orderCode`, `orderLine`
   * @returns {Promise<OrderEntity>} The found `order`
   * @memberof MockOrderService
   */
  getDockets = ({ account, dateTo, dateFrom, order, columns, sort, total }: any) => {
    return {
      subscribe: () => {},
    };
  };

  getActivityLog = async (order: Order) => {
    return getActivityLogService({
      authHeaders: this.authService.createHeaders(),
      httpService: this.httpService,
      order,
    })
  }

  isTooLateForPlusLoad = async ({ orderKey }: { orderKey: string}) => {
    return isTooLateForPlusLoadService({
      authHeaders: this.authService.createHeaders(),
      httpService: this.httpService,
      orderKey,
    })
  }
}

export default MockOrderService;
